// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"User_maincontainer__2lH_b","header":"User_header__rNNn4","button":"User_button__1NUrI","holder":"User_holder__2Uc8K"};